var render = function render(){var _vm=this,_c=_vm._self._c;return _c('QLayout',{attrs:{"view":"lHh lpr lFf"}},[_c('MenuDrawer'),_c('QPageContainer',[_c('QPage',{staticClass:"bg-grey-2 column"},[_c('HeaderWidget',{staticClass:"full-width"}),_c('router-view')],1)],1),_c('QFooter',[_c('InLifeFooterWidget')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }